'use strict';

import GLightbox from 'glightbox'

const SELECTOR = '.js-video-modal';

export function init() {
    const element = document.querySelector(SELECTOR);

    if (!element) {
        return false;
    }

    const lightbox = GLightbox({
        selector: SELECTOR,
        videosWidth: 1280
    });

    // Set fullscreen function enable for brightcove videos

    lightbox.on('slide_after_load', data => {
        const iframe = data.slide.querySelector('iframe');

        if (iframe && iframe.src.includes('players.brightcove.net')) {
            const originalSrc = iframe.src;

            // Set fullscreen attributes
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allow', 'autoplay; fullscreen; encrypted-media');

            // Reload iframe to apply attributes
            iframe.src = '';
            setTimeout(() => {
                iframe.src = originalSrc;
            }, 50);
        }
    });
}
